var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaves(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 869,
    height: 869,
    viewBox: "0 0 869 869",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M434.5 866C672.811 866 866 672.811 866 434.5C866 196.189 672.811 3 434.5 3C196.189 3 3 196.189 3 434.5C3 672.811 196.189 866 434.5 866Z",
    stroke: "white",
    strokeWidth: 4.33474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M434.5 834.531C655.431 834.531 834.531 655.431 834.531 434.5C834.531 213.569 655.431 34.469 434.5 34.469C213.569 34.469 34.4691 213.569 34.4691 434.5C34.4691 655.431 213.569 834.531 434.5 834.531Z",
    stroke: "white",
    strokeWidth: 5.06332,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M434.5 803.062C638.051 803.062 803.062 638.051 803.062 434.5C803.062 230.949 638.051 65.9381 434.5 65.9381C230.949 65.9381 65.9381 230.949 65.9381 434.5C65.9381 638.051 230.949 803.062 434.5 803.062Z",
    stroke: "white",
    strokeWidth: 5.79191,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M434.5 771.593C620.671 771.593 771.593 620.671 771.593 434.5C771.593 248.329 620.671 97.4073 434.5 97.4073C248.329 97.4073 97.4072 248.329 97.4072 434.5C97.4072 620.671 248.329 771.593 434.5 771.593Z",
    stroke: "white",
    strokeWidth: 6.5205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M434.5 740.124C603.291 740.124 740.124 603.291 740.124 434.5C740.124 265.709 603.291 128.876 434.5 128.876C265.709 128.876 128.876 265.709 128.876 434.5C128.876 603.291 265.709 740.124 434.5 740.124Z",
    stroke: "white",
    strokeWidth: 7.24909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M434.5 708.654C585.911 708.654 708.655 585.911 708.655 434.5C708.655 283.089 585.911 160.345 434.5 160.345C283.089 160.345 160.345 283.089 160.345 434.5C160.345 585.911 283.089 708.654 434.5 708.654Z",
    stroke: "white",
    strokeWidth: 7.97715,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M434.5 677.185C568.531 677.185 677.185 568.531 677.185 434.5C677.185 300.469 568.531 191.815 434.5 191.815C300.469 191.815 191.815 300.469 191.815 434.5C191.815 568.531 300.469 677.185 434.5 677.185Z",
    stroke: "white",
    strokeWidth: 8.70574,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M434.5 645.716C551.152 645.716 645.716 551.152 645.716 434.5C645.716 317.848 551.152 223.284 434.5 223.284C317.848 223.284 223.284 317.848 223.284 434.5C223.284 551.152 317.848 645.716 434.5 645.716Z",
    stroke: "white",
    strokeWidth: 9.43433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M434.5 614.301C533.801 614.301 614.301 533.801 614.301 434.5C614.301 335.199 533.801 254.699 434.5 254.699C335.199 254.699 254.699 335.199 254.699 434.5C254.699 533.801 335.199 614.301 434.5 614.301Z",
    stroke: "white",
    strokeWidth: 10.1629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M434.5 582.831C516.421 582.831 582.831 516.421 582.831 434.5C582.831 352.579 516.421 286.169 434.5 286.169C352.579 286.169 286.169 352.579 286.169 434.5C286.169 516.421 352.579 582.831 434.5 582.831Z",
    stroke: "white",
    strokeWidth: 10.8915,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M434.5 551.362C499.041 551.362 551.362 499.041 551.362 434.5C551.362 369.959 499.041 317.638 434.5 317.638C369.959 317.638 317.638 369.959 317.638 434.5C317.638 499.041 369.959 551.362 434.5 551.362Z",
    stroke: "white",
    strokeWidth: 11.6201,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M434.5 519.893C481.661 519.893 519.893 481.661 519.893 434.5C519.893 387.339 481.661 349.107 434.5 349.107C387.339 349.107 349.107 387.339 349.107 434.5C349.107 481.661 387.339 519.893 434.5 519.893Z",
    stroke: "white",
    strokeWidth: 12.3487,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.4d6210c6646b49ee8c3abbc9c8d4c41d.svg";
export { ForwardRef as ReactComponent };